import styled from 'styled-components';

export type SectionHeaderRequireSignProps = {
   readonly required: boolean | undefined;
};

const StyledSectionHeaderRequireSign = styled.span`
   color: ${(props) => props.theme.error};
`;
StyledSectionHeaderRequireSign.displayName = 'StyledSectionHeaderRequireSign';

export const SectionHeaderRequireSign = (props: SectionHeaderRequireSignProps): JSX.Element | null => {
   if (!props.required) {
      return null;
   }
   return <StyledSectionHeaderRequireSign>{'*'}</StyledSectionHeaderRequireSign>;
};
